import { setPosthogAPIKey } from '@/shared/utils/posthog';

setPosthogAPIKey();
